import Button from '@/shared/Button/Button';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext } from 'react';

export default function CraftButtons({ activity }) {
  const globalContext = useContext(GlobalContext);

  return activity.data.file &&
    ((globalContext.state.user?.teacher &&
      globalContext.state.isSubscriptionActive) ||
      globalContext.state.user?.student ||
      activity?.free) ? (
    <Button
      type="primary"
      href={activity.data.file}
      target="_blank"
      rel="noreferrer"
    >
      Download craft template
    </Button>
  ) : null;
}
